import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react'

// Access client environment variables
declare global {
  interface Window {
    CLIENT_ENV: any;
  }
}

const clientEnv = window.CLIENT_ENV || {};

// Log available client environment variables
console.log('Client Environment Variables:', clientEnv);
console.log('Client Environment Variables Keys:', Object.keys(clientEnv));
console.log('Raw window.CLIENT_ENV:', window.CLIENT_ENV);

// Use environment variables without fallbacks
const postHogApiKey = clientEnv.REACT_APP_POSTHOG_API_KEY;
const postHogHost = clientEnv.REACT_APP_POSTHOG_HOST;

// Log environment variables for debugging
console.log('Process Environment Variables:', {
  POSTHOG_API_KEY: postHogApiKey ? 'exists' : 'missing',
  POSTHOG_HOST: postHogHost
});
// Check for required environment variables and print errors
if (!postHogApiKey) {
  console.error('ERROR: PostHog API key is missing! Event tracking will not work.');
}

if (!postHogHost) {
  console.error('ERROR: PostHog host is missing! Using default PostHog host.');
}

// Initialize PostHog only if API key is available
if (postHogApiKey) {
  console.log('Initializing PostHog with:', { host: postHogHost || 'https://us.i.posthog.com' });
  
  posthog.init(postHogApiKey, {
    api_host: postHogHost,
    person_profiles: 'always',
    capture_pageview: true,
    save_referrer: true,
    capture_pageleave: true,
    debug: false,
    loaded: (posthogInstance) => {
      console.log('PostHog loaded successfully');
      // Send a test event
      posthogInstance.capture('app_initialized', { 
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        url: window.location.href
      });
    },
    bootstrap: {
      distinctID: 'user-' + Math.floor(Math.random() * 100000)
    },
    persistence: 'localStorage',
  });
  
  // Add a global error handler to check if PostHog is working
  window.addEventListener('error', function(e) {
    console.error('Global error caught:', e.message);
    if (posthog && typeof posthog.capture === 'function') {
      posthog.capture('js_error', { message: e.message, stack: e.error?.stack });
    }
  });
  
} else {
  console.error('PostHog API key is missing! Event tracking will not work.');
}

const options = {
  api_host: postHogHost,
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={postHogApiKey}
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
